export const catalogHealthScoreV101 = (item) => {
  const score = item?.current_health?.score;
  return typeof score === 'number' && Number.isFinite(score)
    ? Math.max(0, Math.min(100, score))
    : null;
};

export const catalogHealthTextV101 = (language) =>
  language?.startsWith('zh')
    ? {
        label: '当前健康度',
        sort: '按当前健康度',
        hint: '按近期错误估算；1 小时无新错误后逐步恢复，24 小时回到 100%。不是历史成功率或可用性保证。',
        unobserved: '近期无样本，显示默认健康度；尚未经新请求验证。',
        historical: '历史成功率',
      }
    : {
        label: 'Current health',
        sort: 'Current health',
        hint: 'Estimated from recent errors. Recovery starts after 1 hour without new errors and reaches 100% at 24 hours. Not historical success or an availability guarantee.',
        unobserved:
          'No recent samples. Default health, not verified by a new request.',
        historical: 'Historical success',
      };
